<span class="ss-badge" [ngStyle]="{ borderColor: color, color: color }">
  {{name}}
</span>